import { materialSymbols } from "../../../../../shared/constants/material-symbols";
import { IVoteOption } from "../../../../../shared/models/ballot-vote";
import { IVoteOptionWithName } from "../ballot-base/ballot-vote-dto";


export interface ICibVote {
  ballotId: number;
  voteResult: string;
  ballotComment?: string;
  ballotVoteId: number;
}

export interface IVoteRequest {
   ballotId: string
   committeeMemberIds: string[]
   CiVoteOptionId: CiVoteIdDto
   comments: string
}

export interface IProxyVoteRequest {
  ballotId: string
  committeeMemberIds: string[]
  voteOption: CiVoteIdDto
  comments: string
  file: File | null
}


export enum CiVoteId {
  AGREE = "Agree",
  DISAGREE = "Disagree",
  NO_RESPONSE = "NoResponse"
}

export enum CiVoteIdDto {
  Agree = 0,
  Disagree = 1,
  NoResponse = 3
}

export const ciVoteOption: { [key: string]: IVoteOption } = {
  "Agree": {color: '#1A936F', icon: materialSymbols.checkCircle, text: 'Agree'},
  "Disagree": {color: '#CE1114', icon: materialSymbols.cancel, text: 'Disagree'},
  "NoResponse": {color: '#FFB500', icon: materialSymbols.doNotDisturb, text: 'No Response'}
}


export const ciReportVoteTypes = {
  AGREE: { label: "Agree", color: "#00c257" },
  DISAGREE: { label: "Disagree", color: "#2727df" },
  NO_RESPONSE: { label: "No Response", color: "#fdb414" }
};


export const cibVoteDisplayNames = {
  agree: "Agree",
  disagree: "Disagree",
  noResponse: "No Response"
};

export const ciFinaliseVoteOption: { [key: string]: IVoteOptionWithName } = {
  "Agree": {color: '#1A936F', icon: materialSymbols.checkCircle, text: 'Agree', name: 'Agree', id: "agree"},
  "Disagree": {color: '#CE1114', icon: materialSymbols.cancel, text: 'Disagree', name: 'Disagree', id: "disagree"},
  "NoResponse": {color: '#FFB500', icon: materialSymbols.doNotDisturb, text: 'No Response', name: 'NoResponse', id: "no Response"}
}

export interface IFinaliseCiBallotRequest {
  ballotId: string
  finalisedBy: string
  resolution: CommitteeInternalVoteOption
}

export enum CommitteeInternalVoteOption {
  Agree = 0,
  Disagree = 1,
  NoResponse = 2
}
